import { useContext } from 'react';
import { Snackbar, Alert, IconButton } from '@mui/material';
import Context from '../../context';
import CloseIcon from '@mui/icons-material/Close';

const SuccessMessage = (): JSX.Element => {
  const { showSuccess, message, setShowSuccess } = useContext(Context);
  const handleClose = () => setShowSuccess(false);
  return showSuccess ? (
      <Snackbar
        data-testid="successMessage"
        open={true}
        autoHideDuration={4000}
        anchorOrigin={{vertical:'top', horizontal:'center'}}
        onClose={handleClose}>
        <Alert  severity="success" sx={{ width: '100%', position: 'relative' }}
          action={
            <IconButton size="small" color="inherit" onClick={handleClose}>
              <CloseIcon fontSize="small" />
            </IconButton>
          }
        >
          {message}
        </Alert>
      </Snackbar>
  ) : <></>;
}

export default SuccessMessage;